import { extractYouTubeVideoId } from "utils/yt";
import { ResourceName } from "./ResourceName";

interface DownloadableResourceProps {
  name: string;
  description: string;
  link: string;
}

export function YouTubeEmbedResource({ name, description, link }: DownloadableResourceProps) {
  const videoId = extractYouTubeVideoId(link);
  return (
    <>
      <ResourceName name={name} description={description} />

      <div className="mr-9 py-2">
        {videoId ? (
          <YouTubeEmbed videoId={videoId} />
        ) : (
          <div>Błędny link do filmu YouTube. Upewnij się, że link jest poprawny.</div>
        )}
      </div>
    </>
  );
}

const YouTubeEmbed: React.FC<{ videoId: string }> = ({ videoId }) => {
  return (
    <div className="relative w-full max-w-lg">
      <iframe
        className="aspect-video max-h-96 w-full rounded-lg shadow-lg"
        style={{ height: "300px" }}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};
